import { Item } from "../../../../operations"

export interface HoardStatusPDFRow {
  product: string
  unitTotal: string
  quantity: string
  total: string
  section: HoardStatusSection
}

export enum HoardStatusSection {
  DELIVERED = 'Delivered',
  PENDING = 'Pending',
  RETURNED = 'Returned'
}

export type HoardStatusItem = Item & {
  section: HoardStatusSection
}
